'use strict';
/**
 * <tank-studio-panel> - wraps the Tank Design Studio's markup only (stage +
 * canvas + color-swatches container). The actual three.js logic stays in
 * public/tank-studio.js, loaded separately as a module script - it keeps
 * reaching into this panel by the same child ids (#tank-studio-stage,
 * #tank-studio-canvas, #color-swatches), unaffected by this move. See
 * settings-panel.js for the light-DOM / classic-script / load-order
 * rationale shared by all four panel components.
 */
class TankStudioPanel extends HTMLElement {
  connectedCallback() {
    if (this.childElementCount) return;
    this.innerHTML = `
      <div class="settings-header">
        <button id="studio-back-btn" class="icon-btn-inline" aria-label="Back to menu" title="Back to menu">
          <svg class="icon"><use href="#icon-back"/></svg>
        </button>
        <h2>Tank Design Studio</h2>
      </div>
      <div id="tank-studio-stage" class="tank-studio-stage">
        <canvas id="tank-studio-canvas"></canvas>
      </div>
      <div class="color-swatches" id="color-swatches"></div>
    `;
  }
}

customElements.define('tank-studio-panel', TankStudioPanel);
